<template lang="pug">
  .card
    .card-body
      h4.card-title.text-center.d-flex.justify-content-between
        i.fa.fa-chevron-left(@click.prevent="prev()")
        span Emergency Contact / Beneficiaries
        i.fa.fa-chevron-right(@click.prevent="next()")
      hr
      .row
        .col-md-8
          ValidationObserver(ref="Validation" slim)
            ValidationProvider(name="contact person" rules="required" v-slot="{errors}" slim)
              .form-group
                label(for="contact_person") Contact person in case of emergency:
                input.form-control#contact_person(type="text" name="contact_person" placeholder="")
                small.text-danger(v-if="errors.length") {{ errors[0] }}
            ValidationProvider(name="contact number" rules="required" v-slot="{errors}" slim)
              .form-group
                label(for="contact_number") Contact number:
                input.form-control#contact_number(type="text" name="contact_number" placeholder="")
                small.text-danger(v-if="errors.length") {{ errors[0] }}
            ValidationProvider(name="beneficiary (1)" rules="required" v-slot="{errors}" slim)
              .form-group
                label(for="beneficiary_1") Beneficiary (1):
                input.form-control#beneficiary_1(type="text" name="beneficiary_1" placeholder="")
                small.text-danger(v-if="errors.length") {{ errors[0] }}
            ValidationProvider(name="beneficiary (2)" rules="required" v-slot="{errors}" slim)
              .form-group
                label(for="beneficiary_2") Beneficiary (2):
                input.form-control#beneficiary_2(type="text" name="beneficiary_2" placeholder="")
                small.text-danger(v-if="errors.length") {{ errors[0] }}
            ValidationProvider(name="beneficiary (3)" rules="required" v-slot="{errors}" slim)
              .form-group
                label(for="beneficiary_3") Beneficiary (3):
                input.form-control#beneficiary_3(type="text" name="beneficiary_3" placeholder="")
                small.text-danger(v-if="errors.length") {{ errors[0] }}
</template>

<style scoped=""></style>

<script>
  import { ref, reactive } from '@vue/composition-api'
  
  export default {
    name: 'step_3',
    emits: ['prev', 'next'],

    setup(props, {emit}) {
      const Validation = ref(null)
      const prev = () => {
        emit('prev');
      }
      const next = () => {
        emit('next');
      }
      return {
        Validation, prev, next,
      }
    }
  }
</script>